import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import EFPicture from '@elem/compCommon/EFPicture';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import classNames from 'classnames';
import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import './index.scss';
import { Autoplay } from 'swiper';

export interface EcoBlogItemProps extends ImgVideoProps, EcoTabItemProps {}

type FTabTypes = {
    className?: string;
    pc?: string;
    h5?: string;
    pad?: string;
    items: EcoBlogItemProps[];
    layout: 'LImageRText' | 'Image';
};

export default function FTab(props: FTabTypes) {
    const prefixCls = `f-eco-tab`;

    const { className, pc, h5, items, layout = 'Image' } = props;

    const classes = classNames(prefixCls, 'eco-content', {
        [`${className}`]: className,
    });

    const [swiperA, setSwiperA] = useState<any>(null); // 用于点击tab时执行轮播切换
    const [activeIndex, setActiveIndex] = useState(0);

    // 切换
    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        setActiveIndex(index);
        swiperA.slideToLoop(index);
    };

    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        setActiveIndex(index);
    };

    return (
        <div className={classes}>
            <Swiper
                className={`${prefixCls}-s1`}
                loop={true}
                autoplay
                modules={[Autoplay]}
                onSlideChange={handleSlideChange}
                onSwiper={(swiperIns: any) => setSwiperA(swiperIns)}
            >
                {items.map((item, index: number) => {
                    return (
                        <SwiperSlide key={index} className={`${prefixCls}-s1-item`}>
                            {layout === 'Image' && (
                                <div className={`${prefixCls}-img`}>
                                    <EFPicture src={item.pc} srcMobile={item.h5} srcPad={item.pad} />
                                </div>
                            )}
                            {layout === 'LImageRText' && (
                                <div className={`${prefixCls}__content`}>
                                    <div className={`${prefixCls}-l`}>
                                        <EFPicture src={item.pc} srcMobile={item.h5} srcPad={item.pad} />
                                    </div>
                                    <div className={`${prefixCls}-r`}>{item.desc}</div>
                                </div>
                            )}
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            {/* <div className={`${prefixCls}-img`}>
                <EFPicture src={activeItem.pc} srcMobile={activeItem.h5} srcPad={activeItem.pad} />
            </div> */}
            <div className={`${prefixCls}-tab`}>
                <EcoTab activeIndex={activeIndex} onChange={toggleItemHandle} items={items} />
            </div>
        </div>
    );
}
